/**
 * @returns {string} A string representing the domain.
 */
function getDomain () {
	const urlArray = window.location.hostname.split('.');
	const domain = urlArray[urlArray.length - 1];

	if (domain !== 'dev') {
		return domain;
	}
	let tld = /ta([a-z]{0,2})/.exec(urlArray.shift());

	if (tld !== null) {
		tld = tld[1];
		if (typeof (tld) === 'string' && tld.length === 2) {
			return tld;
		}
	}

	return 'nl';

}

/**
 * @returns {boolean} Returns whether we are in production or not
 */
function isProduction () {
	const urlArray = window.location.hostname.split('.');
	const domain = urlArray[urlArray.length - 1];

	return domain !== 'dev';
}


module.exports = {
	getDomain,
	isProduction
};
